enum MutationType {
  SET_CURRENT_PROJECT = "project/SET_CURRENT_PROJECT",
}

export default MutationType;
